module.exports = __webpack_public_path__ + "img/ca_mc.54a12e88.png";